import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import type { SalesloftCadenceStep } from "app/pages/sales-intelligence/modules/salesloft/types/salesloft.types";

import { CadenceStepsTooltipContent } from "./CadenceStepsTooltipContent";

type CadenceStepsSummaryProps = {
    steps?: SalesloftCadenceStep[];
};

const getCadenceLastDay = (steps: SalesloftCadenceStep[]): number | null => steps[steps.length - 1].day ?? null;

export const CadenceStepsSummary = ({ steps }: CadenceStepsSummaryProps) => {
    const { translate } = useTranslate();

    if (!steps?.length) {
        return null;
    }

    const lastDay = getCadenceLastDay(steps);
    const stepsLabel = translate("si.playbooks.cadence.steps.count", { count: steps.length });

    return (
        <Tooltip
            placement="top"
            data-automation="playbook-cadence-steps-summary"
            content={
                <CadenceStepsTooltipContent
                    steps={steps}
                    lastDay={lastDay}
                />
            }
        >
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon["300"]}
                cursor="default"
                flexShrink={0}
                onClick={(event) => event.stopPropagation()}
                data-automation="playbook-cadence-steps"
            >
                {stepsLabel}
                {lastDay !== null ? (
                    <>
                        {" · "}
                        <span data-automation="playbook-cadence-days">
                            {translate("si.playbooks.cadence.steps.days_short", { count: lastDay })}
                        </span>
                    </>
                ) : null}
            </Text>
        </Tooltip>
    );
};
